import { render } from "./businessintroduce.vue?vue&type=template&id=9d6c19a2&scoped=true"
import script from "./businessintroduce.vue?vue&type=script&lang=js"
export * from "./businessintroduce.vue?vue&type=script&lang=js"

import "./businessintroduce.vue?vue&type=style&index=0&id=9d6c19a2&lang=css"
import "./businessintroduce.vue?vue&type=style&index=1&id=9d6c19a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6c19a2"]])

export default __exports__